import { Component, ViewChild } from '@angular/core';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { NgbNav, NgbTooltip, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { GroupTemplateComponent } from './proposal/group-template/group-template.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-templates',
    templateUrl: './templates.component.html',
    styleUrls: ['./templates.component.css'],
    imports: [NgbTooltip, FaIconComponent, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, GroupTemplateComponent, NgbNavOutlet]
})
export class TemplatesComponent {
  @ViewChild('nav') private nav: NgbNav;
  // user: User;

  // Font Awesome Properties
  faAngleLeft = faAngleLeft;

  constructor(
    public location: Location
  ) { }

  async ngOnInit(): Promise<void> {
    // this.user = JSON.parse(localStorage.getItem('login'))
  }

  ngAfterViewInit(): void {
    this.nav.activeIdChange.subscribe((activeId) => {
      sessionStorage.setItem('templateNavActiveId', activeId);
    });
  }

  // Get Current Tab
  getCurrentTab(): string {
    const activeId = sessionStorage.getItem('templateNavActiveId');
    return (activeId === undefined) ? 'PROPOSALS' : activeId;
  }
}
